module.exports = __webpack_public_path__ + "static/logo-c6cd0dfbd92ee1197fd5268e9addb699.svg";